import { HttpClient, HttpContext } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { HELIOS_COMMAND_HTTP_TOKEN } from '@helios/utils'
import { Observable } from 'rxjs'
import { TransactionTypeLabelRequest } from '../models/transaction-type-labels.model'
/**
 * @internal
 */
export const SAVE_TRANSACTION_LABEL = `helios-create-edit-trans/transaction/label`
export const GET_TRANSACTION_LABEL = `helios-create-edit-trans/transaction/labels`
@Injectable({
  providedIn: 'root',
})
export class EditTransactionTypeLabelService {
  constructor(private readonly httpClient: HttpClient) {}

  getTranTypeLabel(): Observable<{ [s: string]: string }> {
    return this.httpClient.get<{ [s: string]: string }>(GET_TRANSACTION_LABEL)
  }
  saveTransactionLabel(
    request: TransactionTypeLabelRequest,
  ): Observable<string> {
    return this.httpClient.put<string>(SAVE_TRANSACTION_LABEL, request, {
      context: new HttpContext().set(HELIOS_COMMAND_HTTP_TOKEN, true),
    })
  }
}
